/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { AccountingSalaryCompanyContext } from './AccountingSalaryCompanyContext';

export default () => React.useContext(AccountingSalaryCompanyContext);
